import { CdrBreakpointMd } from '@rei/cdr-tokens';

export const isDesktop = () => window?.matchMedia(`(min-width: ${CdrBreakpointMd}px)`)?.matches;
export const isMobile = () => !isDesktop();
const getScreenSize = () => (isMobile() ? 'mobile' : 'desktop');

export default getScreenSize;
